import { FormInput, FormInputProps } from '@glow/ui-components'
import { FieldValidator, useField } from 'formik'
import { ChangeEvent, ReactElement, RefObject } from 'react'
import { useFormikError } from '../formik-error'

export interface FormikInputProps extends FormInputProps {
  name: string
  error?: boolean
  onBlur?: (event: any) => void
  type?: string
  errorMessage?: string
  validate?: FieldValidator
  trim?: boolean
  inputRef?: RefObject<HTMLInputElement | null>
  showClear?: boolean
}

export function FormikInput({
  inputRef,
  validate,
  onBlur,
  trim,
  showClear,
  name,
  ...props
}: FormikInputProps): ReactElement {
  const type = props.type ?? 'text'
  const [field, , helpers] = useField({ name, validate })
  const error = useFormikError(name, validate)

  const handleOnBlur = (event: any) => {
    onBlur?.(event)
    field.onBlur(event)
  }

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(event)
    if (trim) {
      helpers.setValue(event.target.value.trim())
    } else {
      field.onChange(event)
    }
  }

  const handleOnClear = () => {
    field.onChange({ target: { name, value: '' } })
  }

  return (
    <FormInput
      {...props}
      {...field}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      onClear={showClear ? handleOnClear : props.onClear}
      type={type}
      aria-invalid={Boolean(error) || props.error}
      errorMessage={error?.message || props.errorMessage}
      ref={inputRef}
    />
  )
}
